module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_function-to-string.js
// module id = 199
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11